import {
  MdDashboard,
  MdFileUpload,
  MdHome,
  MdSettings,
  MdLogout,
  MdCampaign,
  MdFeedback,
  MdPeople,
  MdVerifiedUser,
} from "react-icons/md";
import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../styles/sidebar.css";

const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const activePath = location.pathname;

  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [userType, setUserType] = useState("");
  const [userVerification, setUserVerification] = useState("");

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    if (storedUser) {
      setUserType(storedUser.type || "");
      setUserVerification(storedUser.isVerified || "");
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    navigate("/", { replace: true });
  };

  const hideAdmin = !(userType?.toLowerCase() === "admin");
  const canViewFeedback = !(
    userType?.toLowerCase() === "user" &&
    ["viewer", "pending"].includes(userVerification?.toLowerCase())
  );
  const showVerifyLink = ["pending", "viewer"].includes(
    userVerification?.toLowerCase()
  );

  return (
    <>
      {/* 🔥 Floating Bottom Bar */}
      <nav className="bottom-bar">
        <Link
          to="/dashboard"
          className={activePath === "/dashboard" ? "active" : ""}
        >
          <MdDashboard className="nav-icon" />
          <span>Dashboard</span>
        </Link>

        {hideAdmin && (
          <Link
            to="/upload"
            className={activePath === "/upload" ? "active" : ""}
          >
            <MdFileUpload className="nav-icon" />
            <span>Upload</span>
          </Link>
        )}

        {canViewFeedback && (
          <Link
            to="/scanned-houses"
            className={activePath === "/scanned-houses" ? "active" : ""}
          >
            <MdHome className="nav-icon" />
            <span>Houses</span>
          </Link>
        )}

        <Link
          to="/announcements"
          className={activePath === "/announcements" ? "active" : ""}
        >
          <MdCampaign className="nav-icon" />
          <span>News</span>
        </Link>

        {canViewFeedback && (
          <Link
            to="/feedback"
            className={activePath === "/feedback" ? "active" : ""}
          >
            <MdFeedback className="nav-icon" />
            <span>Feedback</span>
          </Link>
        )}

        {userType === "admin" && (
          <Link to="/users" className={activePath === "/users" ? "active" : ""}>
            <MdPeople className="nav-icon" />
            <span>Users</span>
          </Link>
        )}

        {showVerifyLink && (
          <Link to="/verify" className={activePath === "/verify" ? "active" : ""}>
            <MdVerifiedUser className="nav-icon" />
            <span>Verify</span>
          </Link>
        )}

  
      </nav>

  
      
    </>
  );
};

export default Sidebar;
